import type { Action } from 'redux';

export const REVERT_FILTER_EDITOR = 'REVERT_FILTER_EDITOR' as const;

export const revertFilterEditor = () => ({ type: REVERT_FILTER_EDITOR });

export type RevertFilterEditorResponseAction = Action<typeof REVERT_FILTER_EDITOR>;
